import { EllipsisOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import React from 'react';

// Matches meta-platform-web /business-application-management RowMoreActions.
export default function RowMoreActions({
  items,
}: {
  items: MenuProps['items'];
}) {
  if (!items?.length) return null;
  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button
        type="link"
        size="small"
        icon={<EllipsisOutlined />}
        aria-label="更多操作"
      />
    </Dropdown>
  );
}
